import React from "react"
import "aos/dist/aos.css"
import "./TechCardStyle.css"
import AOS from "aos"

function TechCardLeft(props) {
  AOS.init({
    // initialise with other settings
    duration: 1500
    // offset: 100
  })
  return (
    <div
      className="Techcard mb-3"
      data-aos={window.innerWidth <= 420 ? "fade-up" : "fade-left"}
    >
      <div className="row">
        <div className="col-md-4">
          <img src={props.imageUrl} alt="" className="image-fluid left" />
        </div>

        <div className="col-md-8">
          <div className="Techcard-leftbody">
            <h4 className="Techcard-title">{props.TechTitle}</h4>
            <div className="Techcard-text">{props.TechDescription}</div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default TechCardLeft
